module.exports = __webpack_public_path__ + "img/icon-arrow-below-20@2x.7c92b39e.png";